<template>
    <section>
        <Toolbar :buttonList="buttonList" @callFunction="callFunction"/>

        <TwTable 
            :searchData="searchData"
            :tableData="tableData"
            :tableConfig="tableConfig"
            :pageConfig="pageConfig"
            @selectCurrentRow="selectCurrentRow"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            @handleOperateEvent="handleOperateEvent"
            @handleSelectCheckbox="handleSelectCheckbox"
            @handleCellClick="handleCellClick"
            @searchChange="searchChange"
        >
            <template v-slot:role>
                <el-select multiple v-model="filters.role" placeholder="请选择">
                    <el-option
                        v-for="items in roleIdsOptions"
                        :key="items.id"
                        :label="items.name"
                        :value="items.id"
                    ></el-option>
                </el-select>
            </template>
        </TwTable>

        <!-- 新增 -->
        <OperateDialog :config="editDialogConfig" :formRules="editFormRules" :showOperateDialog="showAddDialog" v-if="showAddDialog" @operateCancel="operateCancel" @operateSubmit="operateSubmit" :formDatas="addFormData">
            
            <template v-slot:roleIds >
                <el-select placeholder="请选择" multiple v-model="addFormData.roleIds">
                    <el-option
                        v-for="items in roleIdsOptions"
                        :key="items.id"
                        :label="items.name"
                        :value="items.id"
                    ></el-option>
                </el-select>
            </template>
        </OperateDialog>

        <!-- 编辑 -->
        <OperateDialog :config="editDialogConfig" :formRules="editFormRules" :showOperateDialog="showAddDialog" v-if="showAddDialog" @operateCancel="operateCancel" @operateSubmit="operateSubmit" :formDatas="formData">
            
            <template v-slot:roleIds >
                <el-select placeholder="请选择" multiple v-model="formData.roleIds">
                    <el-option
                        v-for="items in roleIdsOptions"
                        :key="items.id"
                        :label="items.name"
                        :value="items.id"
                    ></el-option>
                </el-select>
            </template>
        </OperateDialog>

        <!--新增界面-->
        <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
            <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-form-item label="姓名" prop="realName">
                    <el-col :span="16">
                        <el-input v-model="addForm.realName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="登录名" prop="loginName">
                    <el-col :span="16">
                        <el-input v-model="addForm.loginName" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="密码" prop="loginPWD">
                    <el-col :span="16">
                        <el-input v-model="addForm.loginPwd" show-password  auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item label="所属公司" prop="organizationId">
                    <el-select v-model="addForm.organizationId" placeholder="请选择所属公司">
                        <el-option v-for="item in currentUserOrganizations" :key="item.id" :label="item.fullName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="角色" prop="roleIds">
                    <el-select multiple v-model="addForm.roleIds" placeholder="请选择角色">
                        <!-- <el-option  :key="0" :label="'未选择角色'" :value="0"></el-option> -->
                        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-col :span="16">
                        <el-input v-model="addForm.email" auto-complete="off"></el-input>
                    </el-col>
                </el-form-item>
                <!-- <el-form-item label="性别">
                    <el-radio-group v-model="addForm.sex">
                        <el-radio class="radio" :label="1">男</el-radio>
                        <el-radio class="radio" :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄">
                    <el-input-number v-model="addForm.age" :min="0" :max="200"></el-input-number>
                </el-form-item>
                <el-form-item label="生日">
                    <el-date-picker type="date" placeholder="选择日期" v-model="addForm.birth"></el-date-picker>
                </el-form-item> -->
                <el-form-item label="状态" prop="enabled">
                    <el-select v-model="addForm.status" placeholder="请选择状态">
                        <el-option
                        v-for="item in statusList"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="地址">
                     <el-input v-model="addForm.address" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="备注">
                     <el-input v-model="addForm.remark" auto-complete="off" type="textarea" autosize maxlength="200" show-word-limit></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>

        <!-- 数据权限配置界面 -->
        <el-dialog title="数据权限分配" :visible.sync="assignFormVisible" v-model="assignFormVisible" :close-on-click-modal="false">
            <el-card>
                <div slot="header" class="clearfix">
                    <div>
                        <h4>当前用户：{{currentRow?currentRow.realName:''}}</h4>
                    </div>
                    <div class="buttons">
                        <el-button size="mini" @click="setAllChecked">全选</el-button>
                        <el-button size="mini" @click="resetChecked">清空</el-button>
                    </div>
                    
                </div>
                <el-tabs tab-position="right" @tab-click="clickAssignTab">
                    <el-tab-pane label="公司权限">
                        <el-form :v-model="assignForm">
                            <el-form-item label="" prop="organizationIds">
                                <el-checkbox-group v-model="assignForm.ids">
                                    <el-checkbox v-for="org in organizations" :key="org.id" 
                                    :label="org.id" :disabled="org.id==(currentRow!=null?currentRow.organizationId:0)" :title="org.fullName" style="width:150px;">{{cutString(org.fullName,15)}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        
                    </el-tab-pane>
                    <el-tab-pane label="仓库权限">
                        <el-form :v-model="warehouseAssignForm">
                            <el-form-item label="" prop="warehouseIds">
                                <el-checkbox-group v-model="warehouseAssignForm.ids">
                                    <el-checkbox v-for="ware in warehouses" :key="ware.warehouseId" :label="ware.warehouseId" :title="ware.warehouseName" style="width:100px;">{{cutString(ware.warehouseName,6)}}</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
                
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="assignFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="assignSubmit" :loading="assignLoading">提交</el-button>
            </div>
        </el-dialog>

        <LogDialog :tableData="logTableData" :logConfig="logTableConfig" :logPageConfig="logPageConfig" :showLog="showLog" v-if="showLog" @showDialog="showDialog"></LogDialog>
    </section>
</template>

<script>
    import util from '../../../util/date'
    import { cutString } from "../../../util/validate"
    import {testapi, getUserListPage,getRoleListPage ,getOrganizationListPage, removeUser, editUser, addUser, addUserDataPermission,getWarehouseByOrg} from '../../api/api';
    import { getButtonList } from "../../promissionRouter";

    import TwTable from "../../components/TwTable/TwTable";
    import Toolbar from "../../components/Toolbar";
    import OperateDialog from "../../components/TwTable/components/operateDialog";
    import LogDialog from "../../components/TwTable/components/logDialog";

    import {TwTable_mixins} from "../../components/TwTable/mixins";

    export default {
        components: { Toolbar, TwTable, OperateDialog, LogDialog },
        mixins:[TwTable_mixins],
        data() {
            return {
                tableConfig: {
                    showSelection: true, // 显示多选框
                    showRadio: true,     // 显示单选框
                    showIndex: false,    // 显示序号
                    loading: true,       // 显示loading状态
                    showPage: true,      // 显示分页
                    size: 'medium',      // table的尺寸  medium / small / mini
                    showOperate: true,   // 显示操作栏
                    operate: {           // 表格操作配置
                        width:'250',
                        align: 'center',
                        options: [
                            { 
                                name: '编辑',
                                size: 'mini',
                                type: '',
                                event: 'handleEdit',    // 操作的事件名
                            },
                            { 
                                name: '日志',
                                size: 'mini',
                                type: '',
                                event: 'handleLog',
                            },
                            { 
                                name: '删除',
                                size: 'mini',
                                type: 'danger',
                                event: 'handleDel',
                            }
                        ]
                    },
                    column: [            // 表格列配置
                        {
                            prop: 'organizationFullName',
                            label: '所属',
                            align: 'center',
                            sortable: true
                        },
                        {
                            prop: 'realName',
                            label: '姓名',
                            align: 'center',
                            sortable: true
                        },
                        {
                            prop: 'loginName',
                            label: '登录名',
                            align: 'center',
                            sortable: true
                        },
                        {
                            prop: 'roleNames',
                            label: '角色',
                            align: 'center',
                            type: 'tag',
                            sortable: true,
                            formatter: function(val, row){
                                return val
                            }
                        },
                        {
                            prop: 'email',
                            label: '邮箱',
                            align: 'center',
                            sortable: true
                        },
                        {
                            prop: 'status',
                            label: '状态',
                            align: 'center',
                            type: 'tag',
                            sortable: true,
                            formatter: function(val, row){
                                return val === 1 ? "正常-success":"禁用-danger"
                            }
                        }
                    ]
                },
                searchData: {
                    search: [
                        {
                            type: 'input',
                            key: 'keyword',
                            label: '关键字',
                            placeholder: '关键字',
                            clearable: true
                        },
                        {
                            type: 'input',
                            key: 'organizationFullName',
                            label: '所属',
                            placeholder: '所属',
                            clearable: true
                        },
                        {
                            type: 'select',
                            key: 'enabled',
                            label: '状态',
                            placeholder: '状态',
                            clearable: true,
                            multiple: true,
                            options: [
                                {
                                    label: '正常',
                                    value: '1'
                                },
                                {
                                    label: '禁用',
                                    value: '0'
                                }
                            ]
                        },
                        
                            {
                                type: 'select',
                                key: 'role',
                                prop: 'role',
                                label: '角色',
                                multiple: true,
                                slot: true,
                                placeholder: '请选择角色',
                                option: this.roleIdsOptions
                            },
                    ],
                    moreSearch:[
                        {
                            type: 'input',
                            key: 'realName',
                            label: '姓名',
                            placeholder: '姓名',
                            clearable: true
                        },
                        {
                            type: 'select',
                            key: 'roleNames',
                            label: '角色',
                            placeholder: '角色',
                            clearable: true,
                            multiple: true,
                            options: [
                                {
                                    label: '管理员',
                                    value: '1'
                                },
                                {
                                    label: '客户',
                                    value: '0'
                                },
                                {
                                    label: '总监',
                                    value: '2'
                                }
                            ]
                        }
                    ]
                },
                buttonList: [],
                editDialogConfig:{
                    title: '新增',
                    modal: true,
                    closeOnClickModal: false,
                    center: false,
                    showOperateControl: 'showAddDialog',  // 指定每个控件的显隐控制状态
                    formConfig:{
                        labelWidth: '80px',
                        abreast: true,          // 是否两排布局
                        // 两排布局格式
                        items: [
                            [
                                {
                                    type: 'input',
                                    span: 16,
                                    field: 'realName',
                                    label: '姓名',
                                    prop: 'realName',
                                    placeholder: '',
                                    autoComplete: 'off'
                                },
                                {
                                    type: 'input',
                                    span: 16,
                                    field: 'loginName',
                                    label: '登录名',
                                    prop: 'loginName',
                                    placeholder: '',
                                    autoComplete: 'off'
                                }
                            ],
                            [
                                {
                                    field: 'roleIds',
                                    label: '角色',
                                    prop: 'roleIds',
                                    slot: true,
                                },
                                {
                                    type: 'input',
                                    span: 16,
                                    field: 'email',
                                    label: '邮箱',
                                    prop: 'email',
                                    placeholder: '',
                                    autoComplete: 'off'
                                }
                            ],
                            [
                                {
                                    type: 'select',
                                    field: 'status',
                                    label: '状态',
                                    multiple: false,
                                    option: [
                                        {
                                            id: '1',
                                            name: '启用'
                                        },
                                        {
                                            id: '0',
                                            name: '禁用'
                                        }
                                    ]
                                },
                                {
                                    type: 'textarea',
                                    span: 16,
                                    field: 'address',
                                    label: '地址',
                                    prop: 'address',
                                    placeholder: '',
                                    autoComplete: 'off',
                                    autosize: false,
                                    maxlength: 200,
                                    showWordLimit: true
                                }
                            ],
                            [
                                {
                                    type: 'textarea',
                                    span: 16,
                                    field: 'remark',
                                    label: '备注',
                                    prop: 'remark',
                                    placeholder: '',
                                    autoComplete: 'off',
                                    autosize: false,
                                    maxlength: 200,
                                    showWordLimit: true
                                }
                            ]
                        ]

                        // 单排布局格式
                        // items: [
                        //     {
                        //         type: 'input',
                        //         span: 16,
                        //         field: 'realName',
                        //         label: '姓名',
                        //         prop: 'realName',
                        //         placeholder: '',
                        //         autoComplete: 'off'
                        //     },
                        //     {
                        //         type: 'input',
                        //         span: 16,
                        //         field: 'loginName',
                        //         label: '登录名',
                        //         prop: 'loginName',
                        //         placeholder: '',
                        //         autoComplete: 'off'
                        //     },
                        //     {
                        //         field: 'roleIds',
                        //         label: '角色',
                        //         prop: 'roleIds',
                        //         slot: true,
                        //     },
                        //     {
                        //         type: 'input',
                        //         span: 16,
                        //         field: 'email',
                        //         label: '邮箱',
                        //         prop: 'email',
                        //         placeholder: '',
                        //         autoComplete: 'off'
                        //     },
                        //     {
                        //         type: 'select',
                        //         field: 'status',
                        //         label: '状态',
                        //         multiple: false,
                        //         option: [
                        //             {
                        //                 id: '1',
                        //                 name: '启用'
                        //             },
                        //             {
                        //                 id: '0',
                        //                 name: '禁用'
                        //             }
                        //         ]
                        //     },
                        //     {
                        //         type: 'textarea',
                        //         span: 16,
                        //         field: 'address',
                        //         label: '地址',
                        //         prop: 'address',
                        //         placeholder: '',
                        //         autoComplete: 'off',
                        //         autosize: false,
                        //         maxlength: 200,
                        //         showWordLimit: true
                        //     },
                        //     {
                        //         type: 'textarea',
                        //         span: 16,
                        //         field: 'remark',
                        //         label: '备注',
                        //         prop: 'remark',
                        //         placeholder: '',
                        //         autoComplete: 'off',
                        //         autosize: false,
                        //         maxlength: 200,
                        //         showWordLimit: true
                        //     },
                        // ]
                    },
                    footerBtnConfig:[     // footer 的btn配置
                        {
                            type: '',
                            name: '取消',
                            event: 'operateCancel'
                        },
                        {
                            type: 'primary',
                            name: '提交',
                            event: 'operateSubmit'
                        }
                    ]
                },
                showEditDialog: false,
                showAddDialog: false,


                logTableData: [{
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-08',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-06',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }, {
                    date: '2016-05-07',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                    }
                    ],
                logTableConfig: {
                    title: '日志',
                    showPage: false,
                    column: [
                        {
                            prop: 'date',
                            label: '日期',
                            width: '',
                            align: 'center'
                        },
                        {
                            prop: 'name',
                            label: '姓名',
                            width: '',
                            align: 'center'
                        },
                        {
                            prop: 'address',
                            label: '地址',
                            width: '',
                            align: 'center'
                        }
                    ]
                },

                addFormData:{
                    roleIds: []
                },


                //-------------
                filters: {
                    keyword: '',
                    enabled: ''
                },
                users: [],
                organizations: [],
                currentOrganizationId: 0,
                currentUserOrganizations: [],
                warehouses: [],
                roles: [],
                total: 0,
                statusList: [
                    { name: "正常", value: 1 },
                    { name: "禁用", value: 0 }
                ],
                page: 1,
                listLoading: false,
                sels: [],//列表选中列

                addDialogFormVisible: false,
                editFormVisible: false,//编辑界面是否显示
                editLoading: false,
                editFormRules: {
                    loginName: [
                        {required: true, message: '请输入登录名', trigger: 'blur'},
                        { max: 30, message: '最多30个字符', trigger: 'blur'}
                    ],
                    realName: [
                        {required: true, message: '请输入姓名', trigger: 'blur'},
                        { max: 30, message: '最多30个字符', trigger: 'blur'}
                    ],
                    roleIds: [
                        {type: 'array', required: true, message: '请选择角色', trigger: 'change'}
                    ],
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] },
                    ]
                },
                //编辑界面数据
                editForm: {
                    id: 0,
                    roleIds: 0,
                    loginName: '',
                    realName: '',
                    email: '',
                    sex: 1,
                    age: 18,
                    birth: '2021-01-01',
                    address: '',
                    remark: '',
                    status: 1
                },

                addFormVisible: false,//新增界面是否显示
                addLoading: false,
                addFormRules: {
                    loginName: [
                        { required: true, message: '请输入登录名', trigger: 'blur'  },
                        { max: 30, message: '最多30个字符', trigger: 'blur'}
                    ],
                    realName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                        { max: 30, message: '最多30个字符', trigger: 'blur' }
                    ],
                    loginPwd: [
                        { required: true, message: '请输入密码', trigger: 'blur' }
                    ],
                    // organizationId: [
                    //     { required: true, message: '请选择所属公司', trigger: 'blur' }
                    // ],
                    roleIds: [
                        { type: 'array', required: true, message: '请选择角色', trigger: 'change' }
                    ],
                    email: [
                        { required: true, message: '请输入邮箱', trigger: 'blur'},
                        { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur','change'] },
                    ]
                },
                //新增界面数据
                addForm: {
                    loginName: '',
                    realName: '',
                    loginPwd: '',
                    organizationId: 0,
                    email:'',
                    roleIds: 0,
                    sex: 1,
                    age: 18,
                    birth: '2021-01-01',
                    address: '',
                    remark: '',
                    status: 1
                },
                assignFormVisible: false,
                assignLoading: false,
                assignForm: {
                    assignType: 0,
                    ids: [],
                    userId: 0
                },
                warehouseAssignForm: {
                    assignType: 1,
                    ids: [],
                    userId: 0
                },
                tabIndex: '0'
            }
        },
        mounted() {
            getOrganizationListPage({pageSize:100,key:''}).then((res)=>{
                this.organizations = res.data.response.pageData;
            });
            let user = JSON.parse(window.localStorage.user);
            this.currentUserOrganizations = user.organizationList

            this.initTable();

            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];

            this.buttonList = getButtonList(this.$route.path, routers);

            

            getRoleListPage().then((res) => {
                this.roleIdsOptions = res.data.response.pageData;
            });
        },
        methods: {
            callFunction(item) {
                if(item.name === '查询'){
                    this.initTable.apply(this, item);
                }else{
                    this[item.func].apply(this, item);
                }
            },
            //性别显示转换
            formatSex: function (row, column) {
                return row.sex == 1 ? '男' : row.sex == 0 ? '女' : '未知';
            },
            formatBirth: function (row, column) {
                return (!row.birth || row.birth == '') ? '' : util.formatDate.format(new Date(row.birth), 'yyyy-MM-dd');
            },
            handleCurrentChange(val) {
                this.page = val;
                this.initTable();
            },
            //获取用户列表
            initTable() {
                let para = {
                    page: this.page,
                    key: this.filters.keyword,
                    enabled: this.filters.enabled.toString()
                };
                this.tableConfig.loading = true;
                this.tableConfig.showPage = false;
                getUserListPage(para).then((res) => {
                    
                    const {total,pageData,pageIndex} = res.data.response;

                    this.total = total;

                    this.$set(this.pageConfig,'total',total)

                    this.tableData = pageData;
                    this.tableConfig.loading = false;
                    this.tableConfig.showPage = true;
                });
            },
            handleEnable(){
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                    message: "请选择要启用的一行数据！",
                    type: "error"
                    });

                    return;
                }
                if (row.status===1){
                    this.$message({
                        message: "当前数据为启用状态，无需启用！",
                        type: "success"
                    });

                    return;
                }
                row.status = 1;
                let para = Object.assign({}, row);
                editUser(para).then(res => {
                    if (util.isEmt.format(res)) {
                    return;
                    }

                    if (res.data.success) {                
                    this.$message({
                        message: res.data.msg,
                        type: "success"
                    });
                    this.getUsers();
                    } else {
                    this.$message({
                        message: res.data.msg,
                        type: "error"
                    });
                    }
                });
            },
            handleStop(){
                let row = this.currentRow;
                if (!row) {
                    this.$message({
                    message: "请选择要禁用的一行数据！",
                    type: "error"
                    });

                    return;
                }
                if (row.status===0){
                    this.$message({
                        message: "当前数据为禁用状态，无需禁用！",
                        type: "success"
                    });

                    return;
                }
                row.status = 0;
                let para = Object.assign({}, row);
                editUser(para).then(res => {
                    if (util.isEmt.format(res)) {
                        return;
                    }

                    if (res.data.success) {                
                        this.$message({
                            message: res.data.msg,
                            type: "success"
                        });
                        this.getUsers();
                    } else {
                    this.$message({
                        message: res.data.msg,
                        type: "error"
                    });
                    }
                });
            },
            //删除
            handleDel(rows) {
                this.isSelectRow(rows).then((row)=>{

                    this.$confirm('确认删除该记录吗?', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.listLoading = true;
                        //NProgress.start();
                        let para = {id: row.id};
                        removeUser(para).then((res) => {

                            if (util.isEmt.format(res)) {
                                this.listLoading = false;
                                return;
                            }
                            this.listLoading = false;
                            //NProgress.done();
                            if (res.data.success) {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });

                            } else {
                                this.$message({
                                    message: res.data.msg,
                                    type: 'error'
                                });
                            }

                            this.initTable();
                        });
                    }).catch(() => {

                    });
                }).catch((err)=>{});
            },
            //显示编辑界面
            handleEdit(rows) {
                this.isSelectRow(rows).then((row)=>{
                    this.editFormVisible = true;
                    this.editForm = Object.assign({}, row);
                    
                    // 编辑（测试）
                    this.editFormData = Object.assign({}, row);

                    getRoleListPage().then((res) => {

                        this.roleIdsOptions = res.data.response.pageData;

                        // 测试
                        this.showEditDialog = true;
                        this.showAddDialog = true;
                    });

                }).catch((err)=>{});
            },
            //显示新增界面
            handleAdd() {
                this.addFormVisible = true;
                let user = JSON.parse(window.localStorage.user);
                this.addForm = {
                    loginName: '',
                    loginPwd: '',
                    realName: '',
                    organizationId: user.organizationId, 
                    roleIds: 0,
                    sex: -1,
                    age: 0,
                    birth: '',
                    address: '',
                    remark: ''
                };
                getRoleListPage().then((res) => {
                    this.roles = res.data.response.pageData;
                });
            },
            handleAssign(rows) {
                
                this.isSelectRow(rows).then((row)=>{
                    this.assignFormVisible = true;
                    this.assignForm.userId = row.id;
                    this.assignForm.organizationIds = row.organizationIds;
                }).catch((err)=>{});
                
            },
            //编辑
            editSubmit: function () {
                this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.editLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.editForm);

                            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');

                            editUser(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.editLoading = false;
                                    return;
                                }
                                if (res.data.success) {
                                    this.editLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['editForm'].resetFields();
                                    this.editFormVisible = false;
                                    this.initTable();
                                } else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });

                                }
                            });
                        });
                    }
                });
            },
            //新增
            addSubmit: function () {
                this.$refs.addForm.validate((valid) => {
                    if (valid) {
                        this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            this.addLoading = true;
                            //NProgress.start();
                            let para = Object.assign({}, this.addForm);
                            para.birth = (!para.birth || para.birth == '') ? util.formatDate.format(new Date(), 'yyyy-MM-dd') : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd');
                            addUser(para).then((res) => {

                                if (util.isEmt.format(res)) {
                                    this.addLoading = false;
                                    return;
                                }

                                if (res.data.success) {
                                    this.addLoading = false;
                                    //NProgress.done();
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'success'
                                    });
                                    this.$refs['addForm'].resetFields();
                                    this.addFormVisible = false;
                                    this.initTable();
                                }
                                else {
                                    this.$message({
                                        message: res.data.msg,
                                        type: 'error'
                                    });

                                }

                            });

                        });
                    }
                });
            },
            assignSubmit: function() {
                this.assignLoading = true;
                let para = {};
                if (this.tabIndex==='0'){
                    para = Object.assign({}, this.assignForm);
                }else{
                    para = Object.assign({}, this.warehouseAssignForm);
                }
                addUserDataPermission(para).then((res)=>{
                    
                    if (util.isEmt.format(res))
                    {
                        this.assignLoading = false;
                        return;
                    }
                    if(res.data.success){
                        this.$message({
                            message: res.data.msg,
                            type: 'success'
                        });
                        this.assignLoading = false;
                        this.assignForm.ids = [];
                        this.warehouseAssignForm.ids = [];
                        this.assignForm.userId = 0;
                        this.assignFormVisible = false;
                        this.initTable();
                    }else{
                        this.assignLoading = false;
                        this.$message({
                            message: res.data.msg,
                            type: 'error'
                        });
                    }
                });

            },
            setAllChecked: function() {
                var _this = this
                let ids = [];
                if(_this.tabIndex==='0'){
                    for(var i=0;i<_this.organizations.length;i++){
                        ids.push(_this.organizations[i].id);
                    }
                    _this.assignForm.ids = ids;
                }else{
                    for(var i=0;i<_this.warehouses.length;i++){
                        ids.push(_this.warehouses[i].warehouseId);
                    }
                    _this.warehouseAssignForm.ids = ids;
                }
            },

            handleLog(rows){
                const that = this
                this.isSelectRow(rows).then((row)=>{
                    that.showLog = true;
                }).catch((err)=>{});
            },

            operateSubmit(data){
            }
        }
    }

</script>

<style scoped>

</style>
